/**
 * BundleBuilder-local RHF fork of CommonFields/BundleInfo.tsx — mirrors
 * VolumeDiscount/VolumeContentForm/BundleInfo.tsx. Only Title + Offer Name
 * apply to BundleBuilder (the shared component's other fields — popup
 * heading, countdown timer, show-line-around-title — are Volume/ProductAddons
 * -Popup-only conditionals that never render for bundle_builder).
 */
import { useState } from "react";
import styles from "../BundleBuilder.module.css";
import { Collapsible, FormLayout, Label } from "@shopify/polaris";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import useBundleMixpanelHook from "../../../../hooks/useBundleMixpanelHook";
import { FormTextField } from "../../../../components/FormFields";
import { BundleTypes } from "../../constants";
import MonacoEditor from "@monaco-editor/react";
import { useFormContext, useWatch } from "react-hook-form";
import { IS_CUSTOM_CLICK_TO_ADD_GRID_SHOPS } from "../../../constants";

const BundleInfo = () => {
    const [expandBundleInfo, setExpandBundleInfo] = useState(true);
    const { trackFormSections } = useBundleMixpanelHook();

    const { control, setValue } = useFormContext();
    const top_html = useWatch({ control, name: "top_html" });

    return (
        <>
            <div
                className={styles.sectionTitleWrapper}
                onClick={() =>
                    setExpandBundleInfo((ps) => {
                        trackFormSections({
                            cta: "Form Section",
                            ctaType: `Bundle Info ${ps ? "Collapsed" : "Expanded"}`,
                            bundleType: BundleTypes.BUNDLE_BUILDER,
                        });
                        return !ps;
                    })
                }
            >
                <div>Bundle Info</div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transform: expandBundleInfo ? "rotate(90deg)" : "rotate(270deg)",
                    }}
                >
                    <MdOutlineArrowBackIosNew size={14} />
                </div>
            </div>
            <Collapsible
                open={expandBundleInfo}
                id="bundle-info-collapsible"
                transition={{ duration: "500ms", timingFunction: "ease-in-out" }}
                expandOnPrint
            >
                <FormLayout>
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        <FormTextField
                            name="title"
                            label="Title"
                            placeholder="Title"
                            maxLength={80}
                            showCharacterCount
                        />
                        <FormTextField
                            name="offer_name"
                            label="Offer Name"
                            placeholder="Offer name"
                            helpText="This name is only visible to you. It helps you identify the bundle."
                            maxLength={80}
                            showCharacterCount
                        />

                        {IS_CUSTOM_CLICK_TO_ADD_GRID_SHOPS && (
                            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                <Label id="top_html">Top HTML</Label>
                                <MonacoEditor
                                    className={styles.monacoEditor}
                                    height="25vh"
                                    value={top_html || ""}
                                    defaultLanguage="html"
                                    defaultValue={``}
                                    onChange={(value) => {
                                        setValue("top_html", value, { shouldDirty: true });
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </FormLayout>
            </Collapsible>
        </>
    );
};

export default BundleInfo;
